import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { DateInputComponent } from './date-input/date-input.component';
import { ImgCardComponent } from './img-card/img-card.component';
import { SimpleCardComponent } from './simple-card/simple-card.component';
import { GuidedVisitModalComponent } from './guided-visit-modal/guided-visit-modal.component';
import { GuidedVisitPopoverComponent } from './guided-visit-popover/guided-visit-popover.component';
import { HelpPopoverComponent } from './help-popover/help-popover.component';
import { AddAvailabilityModalComponent } from './add-availability-modal/add-availability-modal.component';
import { P2pCardComponent } from './p2p-card/p2p-card.component';
import { CircleProgressBarComponent } from './circle-progress-bar/circle-progress-bar.component';
import { CustomVideoComponent } from './custom-video/custom-video.component';
import { HideModalComponent } from './hide-modal/hide-modal.component';
import { TimerCounterComponent } from './timer-counter/timer-counter.component';
import { PipesModule } from '../_pipes/pipes.module';
import { BreadcrumbCategoryPipe } from './header/pipes/breadcrumb-category.pipe';
import { CustomSkeletonComponent } from './custom-skeleton/custom-skeleton.component';
import { SimulationListHeaderComponent } from './simulation-list-header/simulation-list-header.component';
import { SimulationsInfoModalComponent } from './simulations-info-modal/simulations-info-modal.component';
import { CustomStreamRecordingComponent } from './custom-streaming-recording/custom-stream-recording.component';
import { ChatModalComponent } from './chat-modal/chat-modal.component';
import { NotificationsModalComponent } from './notifications-modal/notifications-modal.component';
import { DeviceSelectorModalComponent } from './device-sector-modal/device-selector-modal.component';
import { CustomStreamDeepgramComponent } from './custom-stream-deepgram/custom-stream-deepgram.component';
import { CardModuleComponent } from './card-module/card-module.component';
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    PipesModule,
    ReactiveFormsModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    DateInputComponent,
    ImgCardComponent,
    SimpleCardComponent,
    GuidedVisitModalComponent,
    GuidedVisitPopoverComponent,
    HelpPopoverComponent,
    AddAvailabilityModalComponent,
    P2pCardComponent,
    CircleProgressBarComponent,
    SimulationListHeaderComponent,
    SimulationsInfoModalComponent,
    ChatModalComponent,
    CardModuleComponent,
    NotificationsModalComponent,
    ComponentsModule.COMPONENTS,
  ],
  declarations: [
    FooterComponent,
    HeaderComponent,
    DateInputComponent,
    ImgCardComponent,
    SimpleCardComponent,
    GuidedVisitModalComponent,
    GuidedVisitPopoverComponent,
    HelpPopoverComponent,
    AddAvailabilityModalComponent,
    P2pCardComponent,
    CircleProgressBarComponent,
    SimulationListHeaderComponent,
    ComponentsModule.COMPONENTS,
    BreadcrumbCategoryPipe,
    ChatModalComponent,
    CardModuleComponent,
    NotificationsModalComponent,
    SimulationsInfoModalComponent,
  ]
})
export class ComponentsModule {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  static COMPONENTS = [
    TimerCounterComponent,
    HideModalComponent,
    CustomVideoComponent,
    DeviceSelectorModalComponent,
    CustomSkeletonComponent,
    CustomStreamRecordingComponent,
    CustomStreamDeepgramComponent
  ];
}
